import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment-timezone';
import {
  Button,
  Dimmer,
  Grid,
  Label,
  Loader,
  Segment,
} from 'semantic-ui-react';

import { fetchM } from '../../../actions/fetchM';
import { checkSvgFormatValid, displaySVG } from '../../../utils/siteplanSVG';
import { siteplanUrl } from '../../../utils/url';

export default class UploadSvgForm extends Component {
  static propTypes = {
    appConfig: PropTypes.shape({}),
    onSubmit: PropTypes.func,
    onChange: PropTypes.func,
    siteplan: PropTypes.shape({
      id: PropTypes.string,
      key: PropTypes.string,
    }),
  }
  static contextTypes = {
    store: PropTypes.object,
  }
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      uploads: [],
    };
  }
  setLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ loading }, () => {
        res(loading);
      });
    });
  }
  submit(url, opts = {}) {
    const { store } = this.context;
    return this.setLoading(true)
      .then(() => store.dispatch(fetchM(url, opts)))
      .then(res => res.json())
      .then(result => this.setLoading(false)
        .then(() => this.resetFiles())
        .then(() => result))
      .catch(err => this.setLoading(false)
        .then(() => this.resetFiles())
        .then(() => Promise.reject(err)));
  }
  resetFiles() {
    // temporary fix for upload modal not closing
    this.setState({
      uploads: [],
    });
  }
  handleSubmit = (event) => {
    event.preventDefault();
    if (this.state.uploads.length > 0) {
      const formData = new FormData(this.form);
      formData.append('file_svg', this.state.uploads[0].file);
      if (this.props.onSubmit) {
        this.props.onSubmit(event, formData);
      }
    }
  }
  handleCheckChanges() {
    if (!this.state.hasChanges) {
      this.setState({ hasChanges: true }, () => {
        if (this.props.onChange) {
          this.props.onChange(true);
        }
      });
    }
  }
  handleOnChange = () => {
    const files = Array.prototype.slice.call(this.uploadFile.files);
    this.uploadFile.value = null;
    if (window.FileReader) {
      files.forEach((file) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          let { uploads } = this.state;
          const name = file.name.substring(0, file.name.length - 4);
          const src = reader.result;
          if (checkSvgFormatValid(src)) {
            uploads[0] = {
              file,
              name,
              src,
            };
          } else {
            uploads = [];
          }
          this.setState({ uploads }, () => {
            this.handleCheckChanges();
          });
        };
        reader.readAsText(file);
      });
    }
  }
  handleRemove = (event) => {
    event.preventDefault();
    this.setState({ uploads: [] });
  }
  handleAddFile = (event) => {
    event.preventDefault();
    this.uploadFile.click();
  }
  render() {
    const { siteplan } = this.props;
    let svgImgUrl;
    if (siteplan && siteplan.id && siteplan.key) {
      svgImgUrl = siteplanUrl(this.props.appConfig, `${siteplan.key}${siteplan.imageUploadedAt ? `_${moment(siteplan.imageUploadedAt).format('YYYYMMDDHHmmss')}` : ''}.jpg`);
    }
    return (
      <form
        encType="multipart/form-data"
        onSubmit={this.handleSubmit}
        name="uploadSvg"
        ref={(ref) => { this.form = ref; }}
      >
        <input
          ref={(ref) => { this.uploadFile = ref; }}
          type="file"
          onChange={this.handleOnChange}
          accept="image/svg+xml"
          style={{ display: 'none' }}
        />
        <Grid verticalAlign="middle" stackable>
          <Grid.Row columns="equal">
            <Grid.Column only="computer" />
            <Grid.Column>
              <Grid verticalAlign="middle" columns="equal">
                <Grid.Column>
                  <Button
                    fluid
                    compact
                    primary
                    icon={this.state.uploads.length < 1 && 'add'}
                    content={this.state.uploads.length > 0 ? 'Replace' : 'SVG'}
                    onClick={this.handleAddFile}
                    disabled={this.state.loading}
                  />
                </Grid.Column>
                <Grid.Column>
                  <Button
                    fluid
                    compact
                    type="submit"
                    positive
                    content="Upload" icon="cloud upload"
                    loading={this.state.loading}
                    disabled={this.state.uploads.length < 1 || this.state.loading}
                  />
                </Grid.Column>
              </Grid>
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <Grid stackable doubling columns={1}>
          <Dimmer style={{ zIndex: 20 }} active={this.state.loading} inverted>
            <Loader indeterminate inline="centered">Uploading</Loader>
          </Dimmer>
          {
            this.state.uploads.length > 0 ? (
              <Grid.Column>
                <Segment>
                  {
                    (this.props.siteplan && this.props.siteplan.id && this.props.siteplan.key) ? (
                      <b>Preview with uploaded image</b>
                    ) : null
                  }
                  <div
                    dangerouslySetInnerHTML={{
                      __html: displaySVG(this.state.uploads[0].src, svgImgUrl),
                    }}
                  />
                  <Label
                    as="a"
                    corner
                    color="red"
                    icon="delete"
                    disabled={this.state.loading}
                    onClick={this.handleRemove}
                  />
                </Segment>
              </Grid.Column>
            ) : null
          }
        </Grid>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Projects/Siteplan/SvgForm.jsx